import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["image"]
  static values = {
    total: Number,
    wait: Number,
    path: String,
  }

  connect() {
    this.currentIndex = 0
    this.startRotation()
  }

  disconnect() {
    clearInterval(this.interval)
  }

  startRotation() {
    this.interval = setInterval(() => {
      this.currentIndex = (this.currentIndex + 1) % this.totalValue
      this.imageTarget.src = `${this.pathValue}${this.getRandomImage()}`
    }, (this.waitValue * 1000))
  }

  getRandomImage() {
    let randomNum
    do {
      randomNum = Math.floor(Math.random() * this.totalValue) + 1
    } while (randomNum === this.currentIndex)
    return `${randomNum}.jpg`
  }
}
